import excelIcon from "Media/icons/simple-microsoftexcel.svg";
import imageIcon from "Media/icons/simple-image.png";
import officeIcon from "Media/icons/simple-microsoftword.svg";
import pdfIcon from "Media/icons/simple-pdf.svg";
import unknownFile from "Media/icons/unknownFile.png";
import videoFile from "Media/icons/videoFile.png";

const FILE_ICONS = {
  png: imageIcon,
  jpg: imageIcon,
  jpeg: imageIcon,
  pdf: pdfIcon,
  docx: officeIcon,
  doc: officeIcon,
  xlsx: excelIcon,
  xls: excelIcon,
  csv: excelIcon,
  mp4: videoFile,
  mkv: videoFile,
  webm: videoFile,
};

// Icon for a file based on the extension of its name; unknown types get a generic icon
const getFileIcon = (fileName) =>
  FILE_ICONS[fileName?.split(".").at(-1)] || unknownFile;

export default getFileIcon;
